import type { Skill } from '../skillsData';

// ===== Exchanges (from skills/exchanges/) =====
// ===== Identity / DID / Reputation (from skills/identity/) =====
// ===== More DeFi (from skills/defi/) =====
// ===== Dev Tools (from skills/dev-tools/) extra =====

export const cryptoskillExchangesIdentityData: Skill[] = [

  // ──────────────────────────────────────────────────────────
  // Exchanges (skills/exchanges/)
  // ──────────────────────────────────────────────────────────
  {
    id: 'binance-official-spot',
    name: 'binance-official-spot',
    author: 'Binance',
    authorHandle: '@binance',
    tag: 'Skill',
    category: 'trading',
    description: 'Official Binance Spot trading skill. Place limit/market orders, manage open orders, query account balances, and stream real-time ticker data via Binance API.',
    downloads: 89400,
    stars: 4470,
    version: '1.0.0',
    installCommand: '> install the binance-official-spot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/binance-official-spot',
    usageExample: '> place limit order\n> cancel open order\n> get account balance',
    detailedDescription: 'Official Binance spot trading integration with full REST and WebSocket support. Place, modify, and cancel limit/market/stop-limit orders, stream order book and ticker data, manage sub-accounts.',
    featured: true,
    trending: true,
  },
  {
    id: 'binance-official-derivatives-usds-futures',
    name: 'binance-official-derivatives-trading-usds-futures',
    author: 'Binance',
    authorHandle: '@binance',
    tag: 'Skill',
    category: 'trading',
    description: 'Binance USDS-M Futures official skill. Trade BTC/ETH/altcoin perpetuals, manage leverage, set TP/SL, and query funding rates on Binance Futures.',
    downloads: 67200,
    stars: 3360,
    version: '1.0.0',
    installCommand: '> install the binance-official-derivatives-trading-usds-futures skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/binance-official-derivatives-trading-usds-futures',
    usageExample: '> open long BTC perp\n> set stop loss\n> query funding rate',
    detailedDescription: 'Binance USDS-M perpetual futures integration. Open/close long and short positions, configure leverage (1-125x), set TP/SL/trailing stops, query funding rates, and access mark price data.',
    featured: true,
  },
  {
    id: 'binance-mcp-server',
    name: 'binance-mcp-server',
    author: 'Binance',
    authorHandle: '@binance',
    tag: 'Skill',
    category: 'trading',
    description: 'Binance MCP server. Full Binance exchange access via Model Context Protocol — spot, futures, margin, Web3, and market data in a unified MCP interface.',
    downloads: 42600,
    stars: 2130,
    version: '1.0.0',
    installCommand: '> install the binance-mcp-server skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/binance-mcp-server',
    usageExample: '> query binance via MCP\n> execute spot trade\n> get market snapshot',
    detailedDescription: 'Official Binance MCP server exposing the complete Binance API suite including spot, USDS-M/COIN-M futures, margin trading, staking, and market data through standardized MCP interfaces.',
    trending: true,
  },
  {
    id: 'binance-grid-trading',
    name: 'binance-grid-trading',
    author: 'Binance',
    authorHandle: '@binance',
    tag: 'Skill',
    category: 'trading',
    description: 'Binance Grid Trading automation. Configure and manage spot/futures grid bots via the Binance API for automated range-bound market strategies.',
    downloads: 28800,
    stars: 1440,
    version: '1.0.0',
    installCommand: '> install the binance-grid-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/binance-grid-trading',
    usageExample: '> create grid bot\n> set price range\n> monitor grid PnL',
    detailedDescription: 'Binance Grid Trading API integration for automating spot and futures grid strategies. Configure grid levels, price ranges, profit targets, and monitor live performance via the Binance Grid API.',
  },
  {
    id: 'bybit-official-skills',
    name: 'bybit-official-skills',
    author: 'Bybit',
    authorHandle: '@bybit_official',
    tag: 'Skill',
    category: 'trading',
    description: 'Official Bybit skill suite. Spot, derivatives, options, and copy-trading on Bybit. Manage positions, query P&L, and access Bybit\'s AI trading signals.',
    downloads: 54600,
    stars: 2730,
    version: '1.0.0',
    installCommand: '> install the bybit-official-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/bybit-official-skills',
    usageExample: '> trade bybit perp\n> join copy trading\n> get AI signal',
    detailedDescription: 'Official Bybit exchange integration covering Unified Account (spot/derivatives/options), USDT/USDC perpetuals, options chain, copy-trading enrollment, and Bybit-native AI trading signal access.',
    featured: true,
  },
  {
    id: 'bybit-api',
    name: 'bybit-api',
    author: 'Bybit',
    authorHandle: '@bybit_official',
    tag: 'Skill',
    category: 'trading',
    description: 'Bybit REST API skill. Direct REST/WebSocket access to Bybit markets – market data, order management, account queries, and risk tools.',
    downloads: 36400,
    stars: 1820,
    version: '5.0.0',
    installCommand: '> install the bybit-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/bybit-api',
    usageExample: '> place bybit order\n> query positions\n> stream order book',
    detailedDescription: 'Bybit V5 API integration supporting all asset categories (spot, linear/inverse perpetuals, options). WebSocket streams for real-time order books, trades, klines, and account position updates.',
  },
  {
    id: 'kraken-official-futures-trading',
    name: 'kraken-official-futures-trading',
    author: 'Kraken',
    authorHandle: '@kraken',
    tag: 'Skill',
    category: 'trading',
    description: 'Official Kraken Futures trading skill. Trade BTC/ETH/SOL perpetuals and fixed-term futures on Kraken with institutional-grade order execution.',
    downloads: 31200,
    stars: 1560,
    version: '1.0.0',
    installCommand: '> install the kraken-official-futures-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/kraken-official-futures-trading',
    usageExample: '> trade kraken futures\n> manage margin\n> set TP/SL orders',
    detailedDescription: 'Official Kraken Futures integration for perpetual and fixed-term futures trading. Supports multi-collateral margin, advanced order types (post-only, fill-or-kill), and real-time position management.',
    featured: true,
  },
  {
    id: 'kraken-official-dca-strategy',
    name: 'kraken-official-dca-strategy',
    author: 'Kraken',
    authorHandle: '@kraken',
    tag: 'Skill',
    category: 'trading',
    description: 'Kraken official DCA strategy skill. Automate dollar-cost averaging on Kraken with flexible schedules, price filters, and multi-asset allocation rules.',
    downloads: 18600,
    stars: 930,
    version: '1.0.0',
    installCommand: '> install the kraken-official-dca-strategy skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/kraken-official-dca-strategy',
    usageExample: '> setup weekly DCA\n> add price conditions\n> multi-asset DCA',
    detailedDescription: 'Kraken DCA automation with customizable intervals, price range filters, allocation splits across multiple assets, and performance tracking via the Kraken native API.',
  },
  {
    id: 'kraken-official-earn-staking',
    name: 'kraken-official-earn-staking',
    author: 'Kraken',
    authorHandle: '@kraken',
    tag: 'Skill',
    category: 'defi',
    description: 'Kraken Earn staking skill. Stake ETH, DOT, SOL and 40+ assets on Kraken for competitive APY rewards with flexible and bonded options.',
    downloads: 14800,
    stars: 740,
    version: '1.0.0',
    installCommand: '> install the kraken-official-earn-staking skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/kraken-official-earn-staking',
    usageExample: '> stake ETH on kraken\n> compare staking APY\n> unstake assets',
    detailedDescription: 'Kraken Earn staking integration supporting 40+ assets with flexible and bonded staking options. Access real-time APY rates, auto-compound settings, and rewards tracking via Kraken API.',
  },
  {
    id: 'gate-mcp',
    name: 'gate-mcp',
    author: 'Gate.io',
    authorHandle: '@gate_io',
    tag: 'Skill',
    category: 'trading',
    description: 'Gate.io official MCP server. Full exchange access via Model Context Protocol covering spot, perpetuals, lending, and Web3 wallet on Gate.io.',
    downloads: 24600,
    stars: 1230,
    version: '1.0.0',
    installCommand: '> install the gate-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/gate-mcp',
    usageExample: '> trade via gate MCP\n> query gate markets\n> access web3 wallet',
    detailedDescription: 'Official Gate.io MCP server providing unified access to spot trading, USDT/BTC-settled perpetuals, margin borrowing, staking, and the Gate.io Web3 wallet through MCP interfaces.',
    trending: true,
  },
  {
    id: 'gate-trading-copilot',
    name: 'gate-trading-copilot',
    author: 'Gate.io',
    authorHandle: '@gate_io',
    tag: 'Skill',
    category: 'trading',
    description: 'Gate.io AI trading copilot. AI-assisted trade execution, market analysis, pattern recognition, and risk management suggestions for Gate.io users.',
    downloads: 16400,
    stars: 820,
    version: '1.0.0',
    installCommand: '> install the gate-trading-copilot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/gate-trading-copilot',
    usageExample: '> analyze market with AI\n> get entry suggestion\n> set risk parameters',
    detailedDescription: 'Gate.io AI trading copilot providing real-time pattern recognition, entry/exit suggestions, position sizing recommendations, and risk management alerts integrated with Gate.io trading APIs.',
  },
  {
    id: 'gate-market-analysis',
    name: 'gate-market-analysis',
    author: 'Gate.io',
    authorHandle: '@gate_io',
    tag: 'Skill',
    category: 'analytics',
    description: 'Gate.io market analysis skill. Token screening, trending coins, market sentiment, whale activity monitoring, and new listing alerts from Gate.io.',
    downloads: 19800,
    stars: 990,
    version: '1.0.0',
    installCommand: '> install the gate-market-analysis skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/gate-market-analysis',
    usageExample: '> screen gate markets\n> monitor whale trades\n> get new listings',
    detailedDescription: 'Gate.io market intelligence covering token screening, trending coin discovery, whale wallet tracking, and new listing alerts with automated notification integration.',
  },
  {
    id: 'hyperliquid',
    name: 'hyperliquid',
    author: 'Hyperliquid',
    authorHandle: '@hyperliquid_x',
    tag: 'Skill',
    category: 'trading',
    description: 'Hyperliquid DEX core skill. Trade 140+ perpetual markets on the Hyperliquid L1 orderbook DEX with CEX-level performance and on-chain settlement.',
    downloads: 61400,
    stars: 3070,
    version: '1.0.0',
    installCommand: '> install the hyperliquid skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/hyperliquid',
    usageExample: '> trade hyperliquid perp\n> place limit order\n> manage positions',
    detailedDescription: 'Hyperliquid L1 DEX integration for trading 140+ perpetual markets with sub-millisecond latency, on-chain order book, cross-margin accounts, vault deposits, and native Python/JS SDK support.',
    featured: true,
    trending: true,
  },
  {
    id: 'hyperliquid-perps',
    name: 'hyperliquid-perps',
    author: 'Hyperliquid',
    authorHandle: '@hyperliquid_x',
    tag: 'Skill',
    category: 'trading',
    description: 'Hyperliquid perpetuals specialist. Advanced perp management including TWAP orders, scaled orders, vault strategies, and on-chain copy-trading.',
    downloads: 42800,
    stars: 2140,
    version: '1.0.0',
    installCommand: '> install the hyperliquid-perps skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/hyperliquid-perps',
    usageExample: '> execute TWAP order\n> join HL vault\n> copy-trade on HL',
    detailedDescription: 'Advanced Hyperliquid perpetuals functionality including TWAP and scaled order execution, vault participation for passive yield, on-chain copy-trading, and cross-margin optimization.',
  },
  {
    id: 'hyperliquid-analyzer',
    name: 'hyperliquid-analyzer',
    author: 'Hyperliquid',
    authorHandle: '@hyperliquid_x',
    tag: 'Skill',
    category: 'analytics',
    description: 'Hyperliquid analytics. On-chain order flow analysis, top trader leaderboard, liquidation data, open interest trends, and vault performance metrics.',
    downloads: 28600,
    stars: 1430,
    version: '1.0.0',
    installCommand: '> install the hyperliquid-analyzer skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/hyperliquid-analyzer',
    usageExample: '> analyze order flow\n> check top traders\n> get liquidation data',
    detailedDescription: 'Hyperliquid on-chain analytics covering order flow, liquidation heatmaps, top trader P&L leaderboard, vault TVL/APR trends, and open interest changes for market intelligence.',
    trending: true,
  },
  {
    id: 'bitget-official-trading',
    name: 'bitget-official-trading',
    author: 'Bitget',
    authorHandle: '@bitgetglobal',
    tag: 'Skill',
    category: 'trading',
    description: 'Official Bitget trading skill. Spot, USDT-M/COIN-M futures, copy-trading, and BGB staking on Bitget with official API integration.',
    downloads: 38600,
    stars: 1930,
    version: '2.0.0',
    installCommand: '> install the bitget-official-trading skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/bitget-official-trading',
    usageExample: '> trade bitget spot\n> join copy trading\n> stake BGB',
    detailedDescription: 'Official Bitget exchange integration covering spot, USDT/COIN-M perpetual futures, options, copy-trading for following top traders, and BGB token staking rewards management.',
  },
  {
    id: 'bitget-wallet-mcp',
    name: 'bitget-wallet-mcp',
    author: 'Bitget',
    authorHandle: '@bitgetglobal',
    tag: 'Skill',
    category: 'tools',
    description: 'Bitget Wallet MCP server. Multichain wallet operations, DEX swaps, NFT management, and DApp browser access via Model Context Protocol.',
    downloads: 14200,
    stars: 710,
    version: '1.0.0',
    installCommand: '> install the bitget-wallet-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/bitget-wallet-mcp',
    usageExample: '> swap via bitget wallet\n> manage NFTs\n> connect to dapp',
    detailedDescription: 'Bitget Wallet Model Context Protocol server providing multichain wallet operations, aggregated DEX swaps, NFT display and transfer, and seamless DApp connectivity across 100+ networks.',
  },
  {
    id: 'coinbase-api-exchange',
    name: 'coinbase-api',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'trading',
    description: 'Coinbase Advanced Trade API. Institutional-grade trading on Coinbase with REST/WebSocket, market/limit/TWAP orders, and portfolio analytics.',
    downloads: 44800,
    stars: 2240,
    version: '3.0.0',
    installCommand: '> install the coinbase-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/coinbase-api',
    usageExample: '> place coinbase order\n> stream market data\n> query portfolio',
    detailedDescription: 'Coinbase Advanced Trade API v3 integration supporting spot and futures trading, TWAP/VWAP execution, portfolio analytics, staking, and Prime brokerage connectivity for institutional workflows.',
    featured: true,
  },
  {
    id: 'binance-trading-bot',
    name: 'binance-trading-bot',
    author: 'Binance',
    authorHandle: '@binance',
    tag: 'Skill',
    category: 'trading',
    description: 'Binance smart trading bot framework. Build and deploy automated trading strategies including grid, DCA, arbitrage, and signal-based bots on Binance.',
    downloads: 52400,
    stars: 2620,
    version: '1.0.0',
    installCommand: '> install the binance-trading-bot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/binance-trading-bot',
    usageExample: '> deploy grid bot\n> run DCA strategy\n> signal-based trading',
    detailedDescription: 'Binance trading bot framework supporting grid trading, DCA, signal-based execution, and arbitrage strategies. Includes backtesting, risk management, and performance dashboard integration.',
    trending: true,
  },
  {
    id: 'kraken-api-exchange',
    name: 'kraken-api',
    author: 'Kraken',
    authorHandle: '@kraken',
    tag: 'Skill',
    category: 'trading',
    description: 'Kraken REST and WebSocket API skill. Full exchange access including spot, futures, staking, and NFT marketplace with institutional-grade security.',
    downloads: 28800,
    stars: 1440,
    version: '2.0.0',
    installCommand: '> install the kraken-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/exchanges/kraken-api',
    usageExample: '> trade kraken spot\n> query balances\n> stream tickers',
    detailedDescription: 'Kraken Exchange API v2 integration with full REST and WebSocket support for spot trading, Kraken Futures, Earn staking, and NFT marketplace operations.',
  },

  // ──────────────────────────────────────────────────────────
  // Identity / DID / Reputation  (skills/identity/)
  // ──────────────────────────────────────────────────────────
  {
    id: 'erc8004-identity',
    name: 'erc8004-identity',
    author: 'ERC-8004 Foundation',
    authorHandle: '@erc8004',
    tag: 'Skill',
    category: 'tools',
    description: 'ERC-8004 on-chain agent identity standard. Register, resolve, and manage AI agent identities on Ethereum with capability attestations and reputation scores.',
    downloads: 14800,
    stars: 740,
    version: '1.0.0',
    installCommand: '> install the erc8004-identity skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/erc8004-identity',
    usageExample: '> register agent identity\n> resolve agent DID\n> update capabilities',
    detailedDescription: 'ERC-8004 agent identity standard implementation for registering on-chain AI agent identities with capability declarations, reputation attestations, and secure key management.',
    featured: true,
  },
  {
    id: 'erc8004-agent',
    name: 'erc8004-agent',
    author: 'ERC-8004 Foundation',
    authorHandle: '@erc8004',
    tag: 'Skill',
    category: 'tools',
    description: 'ERC-8004 agent registration skill. Deploy and manage ERC-8004 compliant AI agent smart contracts with on-chain capability profiles and trust attestations.',
    downloads: 11600,
    stars: 580,
    version: '1.0.0',
    installCommand: '> install the erc8004-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/erc8004-agent',
    usageExample: '> deploy agent contract\n> set capability profile\n> issue trust attestation',
    detailedDescription: 'ERC-8004 agent smart contract deployment and management. Create on-chain agent identities with capability profiles, receive/issue trust attestations, and participate in agent-to-agent trust networks.',
  },
  {
    id: 'erc8004-reputation',
    name: 'erc8004-reputation',
    author: 'ERC-8004 Foundation',
    authorHandle: '@erc8004',
    tag: 'Skill',
    category: 'tools',
    description: 'ERC-8004 reputation system. Build and query on-chain agent reputation scores based on task completion history, peer reviews, and stake-backed endorsements.',
    downloads: 9200,
    stars: 460,
    version: '1.0.0',
    installCommand: '> install the erc8004-reputation skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/erc8004-reputation',
    usageExample: '> query agent reputation\n> issue peer review\n> stake endorsement',
    detailedDescription: 'ERC-8004 on-chain reputation tracking for AI agents. Aggregate task success rates, peer endorsements, stake-weighted reviews, and dispute outcomes into a verifiable reputation score.',
  },
  {
    id: 'id-8004',
    name: '8004',
    author: 'ERC-8004 Foundation',
    authorHandle: '@erc8004',
    tag: 'Skill',
    category: 'tools',
    description: 'Core ERC-8004 standard implementation. Base library for on-chain agent identification, discovery, and interoperability across EVM-compatible networks.',
    downloads: 16800,
    stars: 840,
    version: '1.0.0',
    installCommand: '> install the 8004 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/8004',
    usageExample: '> initialize 8004\n> discover agents\n> verify identity',
    detailedDescription: 'Core ERC-8004 standard library providing base agent identification primitives, discovery protocol, on-chain resolver, and cross-chain identity bridging for EVM networks.',
    featured: true,
  },
  {
    id: 'id-8004scan',
    name: '8004scan',
    author: 'ERC-8004 Foundation',
    authorHandle: '@erc8004',
    tag: 'Skill',
    category: 'analytics',
    description: '8004scan explorer integration. Search, browse, and monitor registered AI agent identities, capability changes, and reputation events on the 8004 network.',
    downloads: 8400,
    stars: 420,
    version: '1.0.0',
    installCommand: '> install the 8004scan skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/8004scan',
    usageExample: '> search agent on 8004scan\n> monitor reputation changes\n> track capability updates',
    detailedDescription: '8004scan block explorer integration for querying the ERC-8004 agent registry. Search agents by address/name, track reputation history, monitor capability declarations, and subscribe to identity events.',
  },
  {
    id: 'lukso-agent',
    name: 'lukso-agent',
    author: 'LUKSO',
    authorHandle: '@lukso_io',
    tag: 'Skill',
    category: 'tools',
    description: 'LUKSO Universal Profile agent. Create and manage LSP3 Universal Profiles for AI agents with rich metadata, permissions, and LUKSO ecosystem integration.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the lukso-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/lukso-agent',
    usageExample: '> create universal profile\n> manage permissions\n> link agent to UP',
    detailedDescription: 'LUKSO Universal Profile integration for AI agents. Create LSP3-compliant profiles with rich metadata, manage permission levels via Universal Receiver, and integrate with LUKSO\'s NFT and social protocols.',
  },
  {
    id: 'billions-did-agent',
    name: 'billions-did-agent',
    author: 'Billions Protocol',
    authorHandle: '@billions_proto',
    tag: 'Skill',
    category: 'tools',
    description: 'Billions Protocol DID agent. Create and manage decentralized identifiers (DIDs) for AI agents with W3C-compliant DID Documents and verifiable credentials.',
    downloads: 7600,
    stars: 380,
    version: '1.0.0',
    installCommand: '> install the billions-did-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/billions-did-agent',
    usageExample: '> create agent DID\n> issue verifiable credential\n> resolve DID document',
    detailedDescription: 'Billions Protocol W3C DID implementation for AI agents. Create method-specific DIDs, manage DID Documents, issue and verify credentials, and participate in decentralized trust networks.',
  },
  {
    id: 'agent8-reputation-layer',
    name: 'agent8-reputation-layer',
    author: 'Agent8',
    authorHandle: '@agent8_xyz',
    tag: 'Skill',
    category: 'tools',
    description: 'Agent8 reputation layer. Track and verify AI agent performance, build cross-platform reputation scores, and enable trust-gated task access.',
    downloads: 9800,
    stars: 490,
    version: '1.0.0',
    installCommand: '> install the agent8-reputation-layer skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/agent8-reputation-layer',
    usageExample: '> build agent reputation\n> verify performance history\n> gate access by score',
    detailedDescription: 'Agent8 cross-platform reputation system aggregating task completion rates, peer endorsements, and on-chain proofs into portable agent reputation scores for trust-gated workflows.',
  },
  {
    id: 'aegisverify',
    name: 'aegisverify',
    author: 'Aegis Protocol',
    authorHandle: '@aegis_protocol',
    tag: 'Skill',
    category: 'tools',
    description: 'AegisVerify identity verification. KYC/AML compliant agent verification with zero-knowledge proof privacy, on-chain attestations, and cross-chain portability.',
    downloads: 8400,
    stars: 420,
    version: '1.0.0',
    installCommand: '> install the aegisverify skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/aegisverify',
    usageExample: '> verify agent identity\n> issue ZK attestation\n> check compliance status',
    detailedDescription: 'AegisVerify privacy-preserving identity verification using zero-knowledge proofs. Issue on-chain compliance attestations without revealing personal data, enabling KYC/AML-compliant agent operations.',
  },
  {
    id: 'maiat-trust',
    name: 'maiat-trust',
    author: 'MaIAT',
    authorHandle: '@maiat_io',
    tag: 'Skill',
    category: 'tools',
    description: 'MaIAT trust oracle. On-chain agent trust scores derived from behavioral analysis, stake-backed endorsements, and historical interaction audits.',
    downloads: 6800,
    stars: 340,
    version: '1.0.0',
    installCommand: '> install the maiat-trust skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/maiat-trust',
    usageExample: '> query trust score\n> stake endorsement\n> audit interactions',
    detailedDescription: 'MaIAT decentralized trust oracle computing agent trust scores from behavioral patterns, stake-weighted endorsements, dispute history, and cross-chain interaction audits.',
  },
  {
    id: 'pinata-erc-8004',
    name: 'pinata-erc-8004',
    author: 'Pinata',
    authorHandle: '@pinatacloud',
    tag: 'Skill',
    category: 'tools',
    description: 'Pinata ERC-8004 metadata storage. Pin AI agent identity metadata to IPFS via Pinata for decentralized, content-addressed agent profile hosting.',
    downloads: 7200,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the pinata-erc-8004 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/pinata-erc-8004',
    usageExample: '> pin agent metadata\n> resolve IPFS profile\n> update agent content',
    detailedDescription: 'Pinata IPFS storage integration for ERC-8004 agent identity metadata. Pin, update, and retrieve agent profile data with guaranteed persistence and fast global access via Pinata\'s CDN.',
  },
  {
    id: 'self-agent-id',
    name: 'self-agent-id',
    author: 'Self Protocol',
    authorHandle: '@selfprotocol',
    tag: 'Skill',
    category: 'tools',
    description: 'Self Protocol agent identification. Passport-based identity verification for AI agents using cryptographic proofs without exposing personal data.',
    downloads: 9600,
    stars: 480,
    version: '1.0.0',
    installCommand: '> install the self-agent-id skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/self-agent-id',
    usageExample: '> verify agent with passport\n> generate proof\n> check compliance tier',
    detailedDescription: 'Self Protocol integration using passport-derived cryptographic proofs for AI agent identity verification. Prove nationality, age, and compliance status without revealing personal information.',
  },
  {
    id: 'toadgang-identity',
    name: 'toadgang-identity',
    author: 'ToadGang',
    authorHandle: '@toadgang_nft',
    tag: 'Skill',
    category: 'tools',
    description: 'ToadGang NFT-based identity. Use ToadGang NFTs as on-chain agent identity credentials for community-gated access and reputation bootstrapping.',
    downloads: 4800,
    stars: 240,
    version: '1.0.0',
    installCommand: '> install the toadgang-identity skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/toadgang-identity',
    usageExample: '> use NFT as identity\n> gate community access\n> bootstrap reputation',
    detailedDescription: 'ToadGang NFT identity system enabling NFT-based agent credentials for gated community access, reputation bootstrapping, and exclusive protocol features for NFT holders.',
  },
  {
    id: 'basecred-8004',
    name: 'basecred-8004',
    author: 'BaseCred',
    authorHandle: '@basecred_base',
    tag: 'Skill',
    category: 'tools',
    description: 'BaseCred ERC-8004 on Base. Native ERC-8004 agent identity registry on Base L2 with low-cost registration, fast finality, and Coinbase integration.',
    downloads: 11200,
    stars: 560,
    version: '1.0.0',
    installCommand: '> install the basecred-8004 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/basecred-8004',
    usageExample: '> register on base\n> link coinbase profile\n> verify base identity',
    detailedDescription: 'BaseCred ERC-8004 deployment on Base L2 with low-cost agent identity registration, native Coinbase profile linking, fast finality, and Base Attestation Station integration.',
  },
  {
    id: 'ack-reputation-layer',
    name: 'ack-reputation-layer',
    author: 'ACK Protocol',
    authorHandle: '@ack_protocol',
    tag: 'Skill',
    category: 'tools',
    description: 'ACK Protocol reputation layer. Acknowledgment-based reputation where agents earn trust by completing verified tasks and receiving explicit on-chain acknowledgments.',
    downloads: 7400,
    stars: 370,
    version: '1.0.0',
    installCommand: '> install the ack-reputation-layer skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/identity/ack-reputation-layer',
    usageExample: '> complete task\n> receive ACK\n> query reputation',
    detailedDescription: 'ACK Protocol reputation system where agents earn verifiable reputation through task completion acknowledgments. Each ACK is a cryptographically signed on-chain confirmation of successful delivery.',
  },

  // ──────────────────────────────────────────────────────────
  // More DeFi  (skills/defi/)
  // ──────────────────────────────────────────────────────────
  {
    id: 'eigenlayer-restaking-agent',
    name: 'eigenlayer-restaking-agent',
    author: 'EigenLayer',
    authorHandle: '@eigenlayer',
    tag: 'Skill',
    category: 'defi',
    description: 'EigenLayer restaking agent. Delegate staked ETH to AVSes, manage restaking positions, track rewards, and optimize operator selection on EigenLayer.',
    downloads: 32400,
    stars: 1620,
    version: '1.0.0',
    installCommand: '> install the eigenlayer-restaking-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/eigenlayer-restaking-agent',
    usageExample: '> restake ETH\n> select operator\n> track restaking APY',
    detailedDescription: 'EigenLayer restaking integration enabling delegation of staked ETH to Actively Validated Services (AVSes). Manage operator selection, track slashing risks, monitor AVS performance, and optimize rewards.',
    featured: true,
    trending: true,
  },
  {
    id: 'balancer-v3-agent',
    name: 'balancer-v3-agent',
    author: 'Balancer',
    authorHandle: '@balancer',
    tag: 'Skill',
    category: 'defi',
    description: 'Balancer v3 agent. Provide liquidity to Balancer weighted/stable/boosted pools, harvest BAL rewards, vote on gauge emissions, and manage veBAL positions.',
    downloads: 18600,
    stars: 930,
    version: '3.0.0',
    installCommand: '> install the balancer-v3-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/balancer-v3-agent',
    usageExample: '> add balancer liquidity\n> harvest BAL rewards\n> vote on gauges',
    detailedDescription: 'Balancer v3 DeFi integration covering weighted, stable, and boosted pool liquidity provision, BAL incentive harvesting, veBAL governance voting, and gauge emissions management.',
  },
  {
    id: 'curve-finance-agent',
    name: 'curve-finance-agent',
    author: 'Curve Finance',
    authorHandle: '@curvefi',
    tag: 'Skill',
    category: 'defi',
    description: 'Curve Finance agent. Swap stablecoins, provide liquidity to Curve pools, lock CRV for veCRV, and vote on gauge weights to boost yields.',
    downloads: 28800,
    stars: 1440,
    version: '2.0.0',
    installCommand: '> install the curve-finance-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/curve-finance-agent',
    usageExample: '> swap via curve\n> add curve liquidity\n> lock CRV for veCRV',
    detailedDescription: 'Curve Finance DeFi integration for optimal stablecoin swaps, liquidity provision across tricrypto/stableswap pools, veCRV locking for boosted yields, and DAO gauge voting.',
    featured: true,
  },
  {
    id: 'convex-finance-agent',
    name: 'convex-finance-agent',
    author: 'Convex Finance',
    authorHandle: '@convexfinance',
    tag: 'Skill',
    category: 'defi',
    description: 'Convex Finance agent. Boost Curve LP yields via Convex, stake CVX for vlCVX, collect CRV/CVX rewards, and vote on Curve gauge allocations.',
    downloads: 22400,
    stars: 1120,
    version: '2.0.0',
    installCommand: '> install the convex-finance-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/convex-finance-agent',
    usageExample: '> deposit to convex\n> stake CVX\n> collect rewards',
    detailedDescription: 'Convex Finance integration for maximizing Curve LP yields. Deposit Curve LP tokens for boosted CRV/CVX rewards, stake CVX for vlCVX governance power, and vote on Curve gauge allocations.',
  },
  {
    id: 'eth-liquid-staking',
    name: 'eth-liquid-staking',
    author: 'Liquid Staking Hub',
    authorHandle: '@lsthub',
    tag: 'Skill',
    category: 'defi',
    description: 'ETH liquid staking aggregator. Compare and stake across Lido, Rocket Pool, Frax, StakeWise, and other LST protocols for optimal yield with minimal friction.',
    downloads: 42600,
    stars: 2130,
    version: '2.0.0',
    installCommand: '> install the eth-liquid-staking skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/eth-liquid-staking',
    usageExample: '> compare LST yields\n> stake to best LST\n> track staking rewards',
    detailedDescription: 'ETH liquid staking aggregator comparing stETH, rETH, frxETH, sfrxETH, osETH, and 15+ LST protocols by APY, liquidity, safety score, and decentralization for optimal staking allocation.',
    featured: true,
  },
  {
    id: 'ethena-agent',
    name: 'ethena-agent',
    author: 'Ethena Labs',
    authorHandle: '@ethena_labs',
    tag: 'Skill',
    category: 'defi',
    description: 'Ethena USDe agent. Mint/redeem USDe, stake for sUSDe yields backed by delta-neutral ETH funding, and monitor Ethena protocol metrics.',
    downloads: 24800,
    stars: 1240,
    version: '1.0.0',
    installCommand: '> install the ethena-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/ethena-agent',
    usageExample: '> mint USDe\n> stake for sUSDe\n> track funding rate',
    detailedDescription: 'Ethena Labs integration for minting/redeeming USDe (delta-neutral synthetic dollar), staking USDe for sUSDe yields, and monitoring ETH perpetual funding rates that back protocol returns.',
    trending: true,
  },
  {
    id: 'cowswap-agent',
    name: 'cowswap-agent',
    author: 'CoW Protocol',
    authorHandle: '@cowprotocol',
    tag: 'Skill',
    category: 'defi',
    description: 'CoW Swap agent. Submit swap intents to CoW Protocol for MEV-protected batch execution, competitive prices, and surplus capture on Ethereum and L2s.',
    downloads: 19800,
    stars: 990,
    version: '2.0.0',
    installCommand: '> install the cowswap-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/cowswap-agent',
    usageExample: '> submit swap intent\n> check quote\n> track settlement',
    detailedDescription: 'CoW Protocol swap agent submitting user trade intents to off-chain solvers for batch MEV protection. Access competitive quotes, monitor settlement status, and capture surplus on Ethereum, Gnosis Chain, and Base.',
  },
  {
    id: 'alienbase-agent',
    name: 'alienbase-agent',
    author: 'AlienBase',
    authorHandle: '@alienbase_fi',
    tag: 'Skill',
    category: 'defi',
    description: 'AlienBase DEX agent. Swap, provide liquidity, and farm on AlienBase — the Velodrome-style DEX native to Base with concentrated liquidity and emissions.',
    downloads: 12600,
    stars: 630,
    version: '1.0.0',
    installCommand: '> install the alienbase-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/alienbase-agent',
    usageExample: '> swap on alienbase\n> add concentrated LP\n> claim ALB rewards',
    detailedDescription: 'AlienBase DEX integration on Base L2 for token swaps, concentrated liquidity provision, yield farming, and ALB token rewards. Supports Velodrome-style vALB voting for gauge emissions.',
  },
  {
    id: 'compound-lending-agent',
    name: 'compound-lending-agent',
    author: 'Compound Finance',
    authorHandle: '@compoundfinance',
    tag: 'Skill',
    category: 'defi',
    description: 'Compound v3 lending agent. Supply assets to earn COMP rewards, borrow against collateral, monitor health factors, and manage Compound Comet positions.',
    downloads: 24200,
    stars: 1210,
    version: '3.0.0',
    installCommand: '> install the compound-lending-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/compound-lending-agent',
    usageExample: '> supply to compound\n> borrow USDC\n> check health factor',
    detailedDescription: 'Compound v3 (Comet) integration for supplying collateral, borrowing USDC/USDT, earning COMP rewards, and monitoring liquidation health factors across Ethereum, Polygon, and Base deployments.',
  },
  {
    id: 'aave-lending-v3-defi',
    name: 'aave-lending-v3',
    author: 'Aave',
    authorHandle: '@aave',
    tag: 'Skill',
    category: 'defi',
    description: 'Aave v3 advanced lending agent. Multi-chain supply/borrow, E-Mode for correlated assets, isolation mode, efficiency mode, and cross-chain flash loans.',
    downloads: 52400,
    stars: 2620,
    version: '3.2.0',
    installCommand: '> install the aave-lending-v3 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/aave-lending-v3',
    usageExample: '> supply with e-mode\n> borrow in isolation\n> execute flash loan',
    detailedDescription: 'Aave v3 comprehensive integration with E-Mode for correlated asset capital efficiency, isolation mode for long-tail assets, multi-chain supply/borrow, and flash loan composability across 12+ deployments.',
    featured: true,
  },
  {
    id: 'dex-aggregator-defi',
    name: 'dex-aggregator',
    author: 'DEX Aggregator',
    authorHandle: '@dex_agg',
    tag: 'Skill',
    category: 'defi',
    description: 'Multi-DEX aggregator skill. Route swaps optimally across Uniswap, Curve, Balancer, Sushi, and 100+ DEXes for best price with split routing.',
    downloads: 38600,
    stars: 1930,
    version: '2.0.0',
    installCommand: '> install the dex-aggregator skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/dex-aggregator',
    usageExample: '> find best swap route\n> execute split swap\n> compare DEX quotes',
    detailedDescription: 'DEX aggregation router splitting trades across 100+ liquidity sources on Ethereum, Arbitrum, Optimism, Base, and Polygon. Gas-optimized routing with MEV protection and slippage guardrails.',
    trending: true,
  },
  {
    id: 'darwinfi-defi',
    name: 'darwinfi',
    author: 'DarwinFi',
    authorHandle: '@darwinfi_io',
    tag: 'Skill',
    category: 'defi',
    description: 'DarwinFi evolutionary DeFi. AI-powered strategy optimization using genetic algorithms that evolve yield farming allocations based on on-chain fitness scores.',
    downloads: 8600,
    stars: 430,
    version: '0.9.0',
    installCommand: '> install the darwinfi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/defi/darwinfi',
    usageExample: '> evolve yield strategy\n> run fitness selection\n> deploy fittest allocation',
    detailedDescription: 'DarwinFi evolutionary algorithm-based DeFi optimization. Strategies compete for fitness based on risk-adjusted returns, automatically mutating and propagating successful gene combinations across generations.',
  },

  // ──────────────────────────────────────────────────────────
  // Extra Dev Tools  (skills/dev-tools/)
  // ──────────────────────────────────────────────────────────
  {
    id: 'foundry-devtools',
    name: 'foundry',
    author: 'Paradigm',
    authorHandle: '@paradigm',
    tag: 'Skill',
    category: 'tools',
    description: 'Foundry smart contract toolkit. Compile, test, fuzz, deploy, and debug Solidity contracts with the blazing-fast Foundry toolchain (Forge + Cast + Anvil + Chisel).',
    downloads: 98400,
    stars: 4920,
    version: '1.0.0',
    installCommand: '> install the foundry skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/foundry',
    usageExample: '> forge build\n> forge test --fuzz-runs 10000\n> cast send',
    detailedDescription: 'Foundry complete Ethereum development toolkit. Forge for fast Solidity testing/fuzzing, Cast for on-chain interaction, Anvil for local fork testing, and Chisel for interactive REPL.',
    featured: true,
    trending: true,
  },
  {
    id: 'hardhat-devtools',
    name: 'hardhat',
    author: 'NomicFoundation',
    authorHandle: '@nomicfoundation',
    tag: 'Skill',
    category: 'tools',
    description: 'Hardhat Ethereum development environment. Compile, test, debug, and deploy Solidity with the most popular JavaScript/TypeScript dev framework.',
    downloads: 124600,
    stars: 6230,
    version: '2.22.0',
    installCommand: '> install the hardhat skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/hardhat',
    usageExample: '> npx hardhat compile\n> npx hardhat test\n> npx hardhat deploy',
    detailedDescription: 'Hardhat Ethereum development environment with rich plugin ecosystem. TypeScript support, console.log debugging, mainnet forking, gas reporting, and integration with OpenZeppelin, Ethers.js, and Waffle.',
    featured: true,
  },
  {
    id: 'moralis-devtools',
    name: 'moralis',
    author: 'Moralis',
    authorHandle: '@moralisweb3',
    tag: 'Skill',
    category: 'tools',
    description: 'Moralis Web3 backend skill. NFT APIs, token balances, transaction history, real-time streams, and auth abstraction for Web3 apps across 20+ chains.',
    downloads: 56400,
    stars: 2820,
    version: '2.0.0',
    installCommand: '> install the moralis skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/moralis',
    usageExample: '> get NFT metadata\n> query wallet balances\n> stream transactions',
    detailedDescription: 'Moralis unified Web3 backend providing NFT metadata, wallet token balances, transaction history, real-time webhook streams, and Web3Auth integration across Ethereum, Solana, and 20+ EVM chains.',
    featured: true,
  },
  {
    id: 'cyfrin-solskill',
    name: 'cyfrin-solskill',
    author: 'Cyfrin',
    authorHandle: '@cyfrinaudits',
    tag: 'Skill',
    category: 'tools',
    description: 'Cyfrin security skill suite. Smart contract audit tools, static analysis, vulnerability pattern detection, and security best-practice enforcement from Cyfrin.',
    downloads: 21800,
    stars: 1090,
    version: '1.0.0',
    installCommand: '> install the cyfrin-solskill skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/cyfrin-solskill',
    usageExample: '> run cyfrin audit\n> detect vulnerabilities\n> generate security report',
    detailedDescription: 'Cyfrin comprehensive smart contract security toolkit including static analysis (Aderyn), vulnerability pattern detection, gas optimization suggestions, and best-practice enforcement for Solidity projects.',
  },
  {
    id: 'wagmi-devtools',
    name: 'wagmi',
    author: 'Wagmi',
    authorHandle: '@wagmi_sh',
    tag: 'Skill',
    category: 'tools',
    description: 'Wagmi React hooks for Ethereum. Connect wallets, read/write contracts, manage transactions, and handle ENS resolution with type-safe React hooks.',
    downloads: 86400,
    stars: 4320,
    version: '2.0.0',
    installCommand: '> install the wagmi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/wagmi',
    usageExample: '> use wagmi connect\n> read contract state\n> write contract tx',
    detailedDescription: 'Wagmi React hooks library for Ethereum with type-safe contract reads/writes, wallet connections (MetaMask, WalletConnect, Coinbase), ENS resolution, transaction tracking, and 20+ chain configs.',
    featured: true,
  },
  {
    id: 'viem-devtools',
    name: 'viem',
    author: 'Wagmi',
    authorHandle: '@wagmi_sh',
    tag: 'Skill',
    category: 'tools',
    description: 'Viem TypeScript Ethereum client. Lightweight, high-performance replacement for ethers.js and web3.js with full TypeScript support and zero dependencies.',
    downloads: 72600,
    stars: 3630,
    version: '2.0.0',
    installCommand: '> install the viem skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/viem',
    usageExample: '> create viem client\n> read contract\n> send transaction',
    detailedDescription: 'Viem TypeScript-first Ethereum library with public/wallet client architecture, full ABI encoding/decoding, type-safe contract interactions, and support for all EVM chains.',
    featured: true,
  },
  {
    id: 'drpc-official-devtools',
    name: 'drpc-official-agent-skills',
    author: 'dRPC',
    authorHandle: '@drpc_io',
    tag: 'Skill',
    category: 'tools',
    description: 'Official dRPC agent skills. Distributed RPC access to 50+ blockchains with automatic failover, latency-based routing, and usage analytics for AI agents.',
    downloads: 18600,
    stars: 930,
    version: '1.0.0',
    installCommand: '> install the drpc-official-agent-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/drpc-official-agent-skills',
    usageExample: '> connect via dRPC\n> query 50 chains\n> monitor latency',
    detailedDescription: 'Official dRPC distributed RPC service integration providing access to 50+ blockchain networks with automatic node failover, latency-based routing, rate limiting, and per-chain usage analytics.',
  },
  {
    id: 'smart-contract-security-devtools',
    name: 'smart-contract-security',
    author: 'SC Security Hub',
    authorHandle: '@sc_security',
    tag: 'Skill',
    category: 'tools',
    description: 'Smart contract security toolkit. Automated audit pipelines, Slither static analysis, Echidna fuzzing, and mutation testing for Solidity and Vyper contracts.',
    downloads: 31200,
    stars: 1560,
    version: '1.0.0',
    installCommand: '> install the smart-contract-security skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/smart-contract-security',
    usageExample: '> run slither analysis\n> fuzz with echidna\n> mutation test',
    detailedDescription: 'Comprehensive smart contract security pipeline combining Slither static analysis, Echidna property-based fuzzing, Mythril symbolic execution, and mutation testing for thorough vulnerability detection.',
  },
  {
    id: 'openzeppelin-skills-devtools',
    name: 'openzeppelin-skills',
    author: 'OpenZeppelin',
    authorHandle: '@openzeppelin',
    tag: 'Skill',
    category: 'tools',
    description: 'OpenZeppelin contract toolkit. Deploy audited ERC-20/721/1155 contracts, manage upgradeable proxies (UUPS/Transparent), and integrate access control.',
    downloads: 118400,
    stars: 5920,
    version: '5.0.0',
    installCommand: '> install the openzeppelin-skills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/dev-tools/openzeppelin-skills',
    usageExample: '> deploy ERC-20\n> upgrade proxy\n> add access control',
    detailedDescription: 'OpenZeppelin v5 smart contract library integration. Deploy battle-tested ERC token standards, manage transparent/UUPS upgradeable proxies, configure role-based access control, and integrate Governor DAO voting.',
    featured: true,
  },
];